const translation = {
  title: 'کاوش',
  sidebar: {
    discovery: 'کشف',
    chat: 'چت',
    workspace: 'فضای کاری',
    action: {
      pin: 'سنجاق کردن',
      unpin: 'برداشتن سنجاق',
      rename: 'تغییر نام',
      delete: 'حذف',
    },
    delete: {
      title: 'حذف برنامه',
      content: 'آیا مطمئن هستید که می‌خواهید این برنامه را حذف کنید؟',
    },
  },
  apps: {
    title: 'کاوش برنامه‌ها توسط دیفی',
    description: 'از این برنامه‌های قالبی بلافاصله استفاده کنید یا برنامه‌های خود را بر اساس این قالب‌ها سفارشی کنید.',
    allCategories: 'پیشنهاد شده',
  },
  appCard: {
    addToWorkspace: 'افزودن به فضای کاری',
    customize: 'سفارشی کردن',
  },
  appCustomize: {
    title: 'ایجاد برنامه از {{name}}',
    subTitle: 'آیکون و نام برنامه',
    nameRequired: 'نام برنامه الزامی است',
  },
  category: {
    Assistant: 'دستیار',
    Writing: 'نوشتن',
    Translate: 'ترجمه',
    Programming: 'برنامه‌نویسی',
    HR: 'منابع انسانی',
    Agent: 'عامل',
    Workflow: 'گردش',
    Entertainment: 'سرگرمی',
  },
}

export default translation
